import {useEffect} from 'react'
import {PageData} from '@github-ui/pull-request-page-data-tooling/page-data'
import type {DiffstatData} from '../payloads/header'
import {pullRequestsLayoutRoute} from '../../routes/layout-route'
import {useRouteQuery} from '@github-ui/react-core/future/use-route-query'

/**
 * Reads the diffstat from the data-router route query and reports it to the
 * parent via `onDiffstat`. Renders nothing.
 *
 * Must only be mounted inside a data router (`useRouteQuery` requires the router
 * loader context). Callers gate this on a data-router check at the render
 * boundary instead of calling the underlying hook conditionally.
 */
export function DiffstatRouterDataBridge({onDiffstat}: {onDiffstat: (diffstat: DiffstatData['diffstat']) => void}) {
  const {data} = useRouteQuery(pullRequestsLayoutRoute, PageData.diffstat)
  const diffstat = data?.diffstat

  useEffect(() => {
    onDiffstat(diffstat)
  }, [diffstat, onDiffstat])

  return null
}
